<section class="p-2 px-md-4 py-md-4">
    <div class="d-flex justify-content-between mt-3">
        <div class="back-button mb-3">
            <span class="back-icon" (click)="goBack()"><i class="fa-solid fa-arrow-left"></i></span>
            <h4 class="back-button-heading mx-3">{{'compare_products' | translate}} <span class="quotation-number">({{'quo_num' | translate}} : {{quotesInfo.QuotationNumber}})</span></h4>
        </div>
    </div>
    <section class="mt-4">
        <div class="">
            <div class="table-responsive table-block">
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th class="fixed-column-1 fixed-column--index-2">{{'coverages' | translate}}</th>
                            <th class="fixed-column-2 fixed-column--index-2">{{'cover_limits' | translate}}</th>
                            <th *ngFor="let product of productDetails" class="text-center">
                                {{ product.ProductName }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let coverage of coveragesList">
                            <tr
                                *ngFor="let data of (coverage.additionalData.length ? coverage.additionalData : [{}]); let i = index">
                                <ng-container *ngIf="i === 0">
                                    <td [attr.rowspan]="coverage.additionalData.length || 1" class="fixed-column-1">{{
                                        coverage.CoverageName }}</td>
                                </ng-container>
                                <td *ngIf="data.AdditionalCoverageLabel" class="fixed-column-2">{{
                                    data.AdditionalCoverageLabel }}</td>
                                <td *ngIf="!data.AdditionalCoverageLabel" class="text-center fixed-column-2">-</td>
                                <td *ngFor="let product of productDetails" class="text-center">
                                    <ng-container
                                        *ngIf="product.coverageQuotesCompare[coverage.CoverageID] && product.coverageQuotesCompare[coverage.CoverageID][data.AdditionalCoverageID]; else noData">
                                        <div class="text-center text-success">
                                            <i class="fa-solid fa-check"></i>
                                        </div>
                                        <div>
                                            {{
                                            product.coverageQuotesCompare[coverage.CoverageID][data.AdditionalCoverageID]
                                            }}
                                        </div>
                                    </ng-container>
                                    <ng-template #noData>
                                        <div class="text-center text-red">
                                            <i class="fa-solid fa-xmark"></i>
                                        </div>
                                    </ng-template>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</section>